<script setup lang="ts">

</script>

<template>
  <div class="flex h-64 items-center justify-center">
    <span class="i-local-loading size-16 animate-spin text-primary" />
  </div>
</template>
